<div class="container">
    <lib-generic-type-ahead-multiselect
        [source]="userItems"
        [selectedItems]="selectedUsers"
        (selectedItemsChange)="onSelectedUserChange($event)"
        [config]="{
            defaultText: 'Add Opportunity User',
            itemDisplayKey: 'userFullName',
            itemTemplate: userTemplate
        }"
        [placeholder]="(isReadOnly && !bindingProperty) || !label ? 'Select an Item' : 'Search Users'"
        (textChange)="onUserTextChange($event)"
        removeKey="userExternalId"
        [isReadOnly]="isReadOnly"
        [error]="!isValid"
    >
    </lib-generic-type-ahead-multiselect>
    <app-validation-error-message [show]="!isValid" [errors]="validationErrors"></app-validation-error-message>
</div>

<ng-template #userTemplate let-data>
    <app-custom-menu-item
        [inputText]="data.inputText"
        [title]="
            $safeNavigationMigration(data.object?.firstName) + ' ' + $safeNavigationMigration(data.object?.lastName)
        "
        [subtitle]="data.object?.email ?? ''"
    >
    </app-custom-menu-item>
</ng-template>
